import { render, staticRenderFns } from "./CommonPageCopy.vue?vue&type=template&id=2ed12e3a"
import script from "./CommonPageCopy.vue?vue&type=script&lang=js"
export * from "./CommonPageCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports